import { vehiclesBackground, vehiclesFont } from "../data/vehicles.data";
import { ModelType } from "../types/models";
import { Vehicles } from "../types/vehicles";

export interface IHttpResponse extends Response {
	parsedBody?:  Vehicles
}

class VehiclesService {
  private baseUrl: string;

  public constructor(url: string) {
    this.baseUrl = url;
  }

  	getModels = () : Promise<IHttpResponse> => {
		return new Promise((resolve, reject) => {
			let response : IHttpResponse;
			const url = this.baseUrl + "/api/maintenance-timeline/models";

			fetch(url, {method: "POST" })
				.then(res => {
					response = res;
					return res.json();
				})
				.then(body => {
					if(response.ok) {
						const parsedBody : Vehicles = (Object.values(body) as unknown as ModelType[]).map(model => {
							return {
								model : model,
								background: vehiclesBackground[model],
								fontColor: vehiclesFont[model]
							}
						})

						response.parsedBody = parsedBody;
						resolve(response);
					}
					else {
						reject(response);
					}
				})
				.catch(err => {
					reject(err);
				});
		});
  	}
}

export default VehiclesService;
